export default function Footer() {
  return (
    <div className="text-center bg-neutral-500 text-white text-2xl py-4 mt-auto">Footer</div>
  )
}